// extracted by css-extract-rspack-plugin
export default {"content":"product-detail-fragment__AccordionContent_content__pn8Xk"};